import { render, staticRenderFns } from "./MbInputDropDown.vue?vue&type=template&id=5e1e8e89&scoped=true&"
import script from "./MbInputDropDown.vue?vue&type=script&lang=js&"
export * from "./MbInputDropDown.vue?vue&type=script&lang=js&"
import style0 from "./MbInputDropDown.vue?vue&type=style&index=0&id=5e1e8e89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1e8e89",
  null
  
)

export default component.exports